<template>
    <div style="" ref="animationSubscribe" class="subscribe">
        <div style="text-align:center;" class="subscribe-item">
            <img src="../assets/projects/subscribe.jpg" class="custom-image animation-crad subscribe-image" loading="lazy" decoding="async" />
        </div>
        <div class="subscribe-item">
            <div class="subscribe-text">
                <div class="animation-title big-title">
                    <span class="big-title-art">S</span>UBSCRIBE
                </div>
                <div class="animation-title big-title">
                    TO OUR NEWSLETTER
                </div>
                <div style="display:flex;" class="subscribe-email">
                    <div style="width:500px;">
                        <el-input v-model="email" placeholder="email" style="height: 40px;"></el-input>
                    </div>
                    <div style="margin-left:20px;">
                        <button class="submit" @click="submit">VALIDER</button>
                    </div>
                </div>

                <div style="color: rgb(113, 113, 113);font-size:16px;margin-bottom:30px;">
                    Suscribe to our newsletter to recelve news on update.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ElMessage } from 'element-plus'
    import { createScrollReveal } from '../utils/scrollReveal'

    export default {
        name: 'NewsletterSubscribe',
        data() {
            return {
                email: '',
                revealCleanup: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.revealCleanup = createScrollReveal(this.$refs.animationSubscribe)
            });
        },
        beforeUnmount() {
            if (this.revealCleanup) {
                this.revealCleanup()
                this.revealCleanup = null
            }
        },
        methods: {
            submit() {
                ElMessage({
                    message: 'Subscription successful.',
                    type: 'success',
                })
            }
        }
    }
</script>

<style scoped>
    .submit {
        width: 100px;
        height: 40px;
        background: #000000;
        color: white;
        border: none;
        padding: 15px 0;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.22s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

        .submit:hover {
            background: #433c40;
        }

    @media (prefers-reduced-motion: reduce) {
        .submit {
            transition: none;
        }
    }
</style>
